import fila from './filaRepository'

export default baseUrl => {

    baseUrl = `${baseUrl}/regulacao-divulgacao`

    return {
        fila: fila(baseUrl),

    }
}